import { Assert } from '@team/assert';

const EMPTY_STRING_LENGTH = 0;

export function isEmpty(value: string) {
  return Assert.isEquals(value.length, EMPTY_STRING_LENGTH);
}
